const SAT_014_DEV_API_BASE_URL =
  "https://sat-014-dev.icyplant-eaa05876.koreacentral.azurecontainerapps.io";

function defaultBaseUrlByMode(mode: string): string {
  if (mode === "mock") return "";
  if (mode === "dev") return SAT_014_DEV_API_BASE_URL;
  return "";
}

const baseUrl = import.meta.env.VITE_API_BASE_URL || defaultBaseUrlByMode(import.meta.env.MODE);

export class URLList {
  static AUTH = {
    GET_SECRET_KEY_BY_COOKIE: `${baseUrl}/auth/keys`,
    GET_SECRET_KEY: `${baseUrl}/auth/keys`,
    EXCHANGE_ACCOUNT_SETUP_TOKEN: `${baseUrl}/auth/web/account-setup/token`,
    VERIFY_ACCOUNT_SETUP_IDENTITY: `${baseUrl}/auth/app/account-setup/identity`,
    COMPLETE_APP_ACCOUNT_SETUP: `${baseUrl}/auth/app/account-setup`,
    CHECK_USER_ID_AVAILABLE: `${baseUrl}/auth/check/login-id`,
    INIT_SN_ON_ACCOUNT_SETUP_LINK: `${baseUrl}/auth/sn/init/link`,
    LOGIN: `${baseUrl}/auth/web/login`,
    CHECK_LOGIN: `${baseUrl}/auth/web/login`,
    LOGOUT: `${baseUrl}/auth/user/logout`,
    RESET_TOKEN: `${baseUrl}/auth/user/web/token`,
    USER_TOKEN_CHECK: `${baseUrl}/auth/user/web/token`,
    ISSUE_FIND_SN_CODE: `${baseUrl}/auth/app/find/sn/code`,
    ISSUE_WEB_FIND_SN_EMAIL_CODE: `${baseUrl}/auth/web/find/sn/code`,
    CHECK_FIND_SN_CODE: `${baseUrl}/auth/find/sn/code/check`,
    CHANGE_PASSWORD_BY_VERIFICATION: `${baseUrl}/auth/user/sn/by-verification`,
    ISSUE_WEB_FIND_SN_LINK: `${baseUrl}/auth/find/sn/link`,
    CHANGE_PASSWORD_BY_FIND_LINK: `${baseUrl}/auth/user/sn/by-find-link`,
    /** @deprecated Use ISSUE_WEB_FIND_SN_LINK */
    SEND_RESET_SN_EMAIL: `${baseUrl}/auth/find/sn/link`,
    CHANGE_PASSWORD: `${baseUrl}/s/auth/user/sn`,
    UPDATE_PASSWORD_EXPIRE_DATE: `${baseUrl}/s/auth/sn/updatedAt`,
  };

  static USER = {
    LOGIN: `${baseUrl}/auth/web/login`,
    LOGOUT: `${baseUrl}/auth/user/logout`,
    RESET_TOKEN: `${baseUrl}/auth/user/web/token`,
    GET_USER_INFO: `${baseUrl}/s/user/web/info`,
    CREATE_TEMP: `${baseUrl}/user/temp`,
    CHANGE_PASSWORD: `${baseUrl}/s/auth/user/sn`,
  };

  static HOSPITAL = {
    GET_HOSPITAL_INFO: `${baseUrl}/s/hospital`,
    POST_ADD_HOSPITAL: `${baseUrl}/s/hospital`,
    GET_HOSPITAL_LIST: `${baseUrl}/s/hospital`,
    DELETE_HOSPITAL: `${baseUrl}/s/hospital`,
  };

  static TREATMENT = {
    LIST: `${baseUrl}/s/treatment`,
    DETAIL: `${baseUrl}/s/treatment`,
    ADD_TREATMENT: `${baseUrl}/s/treatment`,
    FINISH: `${baseUrl}/s/treatment`,
  };

  static DASHBOARD = {
    GET: `${baseUrl}/s/patient/doctor/home`,
    DOCTOR_HOME: `${baseUrl}/s/patient/doctor/home`,
    ADMIN_HOME: `${baseUrl}/s/patient/admin/home`,
    SEND_NOTIFICATION: `${baseUrl}/s/doctor/patients/message`,
  };

  static PATIENT = {
    LIST: `${baseUrl}/s/patient/admin`,
    LIST_BY_ADMIN: `${baseUrl}/s/patient/admin`,
    LIST_BY_DOCTOR: `${baseUrl}/s/patient/doctor`,
    DETAIL: `${baseUrl}/s/patient`,
    CREATE: `${baseUrl}/s/patient`,
    UPDATE: `${baseUrl}/s/patient`,
    RESEND_ACCOUNT_SETUP_SMS: `${baseUrl}/s/patient`,
    ACTIVATE: `${baseUrl}/s/user`,
    DEACTIVATE: `${baseUrl}/s/user`,
  };

  static DOCTOR = {
    LIST: `${baseUrl}/s/doctor`,
    CHARGE_LIST: `${baseUrl}/s/doctor/chargeList`,
    DETAIL: `${baseUrl}/s/doctor`,
    CREATE_DOCTOR: `${baseUrl}/s/doctor`,
    CREATE_NURSE: `${baseUrl}/s/user/nurse`,
    CREATE_CRO: `${baseUrl}/s/user/cro`,
    UPDATE: `${baseUrl}/s/doctor`,
    RESEND_ACCOUNT_SETUP_EMAIL: `${baseUrl}/s/doctor`,
    ACTIVATE: `${baseUrl}/s/user`,
    DEACTIVATE: `${baseUrl}/s/user`,
  };

  static PRESCRIPTION = {
    LIST: `${baseUrl}/s/treatment`,
    DETAIL: `${baseUrl}/s/treatment`,
    CREATE: `${baseUrl}/s/treatment`,
    CANCEL: `${baseUrl}/prescription`,
    ACTIVITY_LIST: `${baseUrl}/s/activity/prescription`,
    ACTIVITY_DETAIL: `${baseUrl}/s/record`,
    HEART_RATE_CHART: `${baseUrl}/s/record`,
    EYE_CHART: `${baseUrl}/s/record`,
    SEND_MESSAGE: `${baseUrl}/s/doctor/encouragement`,
    SUBMIT_ACTIVITY_FEEDBACK: `${baseUrl}/s/feedback`,
  };

  static LOG = {
    LIST: `${baseUrl}/s/operation-log`,
  };
}

export const POLICY_CONSENT_URL = {
  Privacy: (locale: string) => `/policy-consent/${locale}/Privacy.md`,
  TermsOfService: (locale: string) => `/policy-consent/${locale}/TermsOfService.md`,
};
